var utils = {};

/**
 * Disable a {jQuery, Node, NodeList} element.
 * - Add a 'disabled' class
 * - Set 'disabled' property to TRUE
 */
utils.disable = function(element) {

  if (!element) return;

  else if (element instanceof jQuery) {

    element.addClass('disabled');
    element.prop('disabled', true);

  } else if (element instanceof Node) {

    element.classList.add('disabled');
    element.disabled = true;

  } else if (element instanceof NodeList) {

    [].forEach.call(element, function(elt) {
			elt.classList.add('disabled');
			elt.disabled = true;
		});

  }
}
/**
 * Enable a {jQuery, Node, NodeList} element.
 * - Remove 'disabled' class
 * - Set 'disabled' property to FALSE
 */
utils.enable = function(element) {

  if (!element) return;

  else if (element instanceof jQuery) {

    element.removeClass('disabled');
    element.prop('disabled', false);

  } else if (element instanceof Node) {

    element.classList.remove('disabled');
    element.disabled = false;

  } else if (element instanceof NodeList) {

    [].forEach.call(element, function(e) {
			e.classList.remove('disabled');
			e.disabled = false;
		});

  }
}

/**
 * Display a loader on a {jQuery, Node, NodeList} element
 * - Add a 'loading' class
 */
utils.displayLoader = function(element) {

  if (!element) return;

  else if (element instanceof jQuery)
    element.addClass('loading');

  else if (element instanceof Node)
    element.classList.add('loading');

  else if (element instanceof NodeList)
    [].forEach.call(element, function(e) { e.classList.add('disabled'); });

}
/**
 * Remove loader from a {jQuery, Node, NodeList} element
 * - Remove 'loading' class
 */
utils.hideLoader = function(element) {

  if (!element) return;

  else if (element instanceof jQuery)
    element.removeClass('loading');

  else if (element instanceof Node)
    element.classList.remove('loading');

  else if (element instanceof NodeList)
    [].forEach.call(element, function(e) { e.classList.remove('disabled'); });

}

/**
 * Return a url with query string parameter updated
 * ex: "?page=2"
 */
utils.updateUrlParameter = function(uri, key, value) {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
};

module.exports = utils;



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-utils.js